var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefaultTagVertical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 75,
    viewBox: "0 0 25 75",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 75V15C0 6.716 6.716 0 15 0h10v60c0 8.284-6.716 15-15 15H0z",
    fill: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Maxis-Bold, Maxis",
    fontSize: 12,
    fontWeight: "bold",
    letterSpacing: 0.5,
    fill: "#8D8E97",
    transform: "rotate(-90 12.5 37.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.528,
    y: 41
  }, "DEFAULT")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultTagVertical);
export default __webpack_public_path__ + "static/media/default-tag-vertical.4e8a8fdca7986b7a1123f624c830a08f.svg";
export { ForwardRef as ReactComponent };